import React, { useContext, useEffect, useState } from "react";
import { Box, Button, Container, LinearProgress, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { Link as RouterLink, useParams } from "react-router-dom";
import { useNavigate } from "react-router";
import bkstApi from "../../api";
import KitchenOrder from "../components/KitchenOrder";
import { UserContext } from "../../context/UserContext";
import { mergeItemProgress } from "../../common/util";

const TRACKER_ORDER_BASE = "/production/tracker/order";

function canOpenFullOrder(role) {
  return role !== "kitchen" && role !== "clerk";
}

// Always focused kitchen item view — used from Production Tracker for every role.
export default function ProductionTrackerItem(props) {
  const { user } = useContext(UserContext);
  const navigate = useNavigate();
  const { orderId, itemIndex } = useParams();

  const trackerBackPath = (() => {
    try {
      return sessionStorage.getItem("productionTrackerReturn") || "/production/tracker";
    } catch {
      return "/production/tracker";
    }
  })();

  const [order, setOrder] = useState();

  useEffect(() => {
    bkstApi(`/my/order/${orderId}`)
      .then((res) => setOrder(res.data))
      .catch(() => navigate(trackerBackPath));
  }, [orderId]);

  if (!order) {
    return <LinearProgress />;
  }

  return (
    <Container maxWidth="md">
      <Box
        mt={2}
        sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 1 }}
      >
        <Button startIcon={<ArrowBackIcon />} onClick={() => navigate(trackerBackPath)}>
          Back
        </Button>
        {canOpenFullOrder(user?.role) && (
          <Button
            component={RouterLink}
            to={`/order/${orderId}`}
            color="secondary"
            endIcon={<OpenInNewIcon />}
          >
            View full order
          </Button>
        )}
      </Box>
      <Box mt={2} mb={1}>
        <Typography variant="h2">Item Production Details</Typography>
      </Box>
      <KitchenOrder
        order={order}
        focusIndex={Number(itemIndex)}
        basePath={TRACKER_ORDER_BASE}
        onItemProgressChange={({ items }) =>
          setOrder((prev) => ({ ...prev, items: mergeItemProgress(prev.items, items) }))
        }
      />
    </Container>
  );
}
